import { render, staticRenderFns } from "./ChoosePeriodModal.vue?vue&type=template&id=22189737&"
import script from "./ChoosePeriodModal.vue?vue&type=script&lang=js&"
export * from "./ChoosePeriodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports